/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import React from "react";
import styled from "styled-components";
import moment from "moment";
import { Signature } from "../../../../../components/Common/Signature";
import "./table.css";
import {
  currency_format,
  currency_format_riel,
  overweight_calculate,
  JOONAAK_COLOR,
  getAddressText
  //COD_FEE,
  //BUS_FEE
} from "../../../../../utils/General";

import {
  getStandardDeliveryQTYByZone,
  getAmountInUSD,
  getTotal,
  getProvinceQTY,
  getStandardCycleDeliveryQTYByZone,
  singleOrPlural,
  getWareHouseCalculation
} from "./actions";
import _ from "lodash";

const vitalBulkId = "cjqt9t2k3a55r0950b49yr54i";

const Container = styled.div`
  padding: 50px;
`;

const Header = styled.div``;

const BoldText = styled.p`
  font-weight: 600;
  padding: 0;
  margin: 0;
  font-family: "Khmer OS Content Regular", arial, sans-serif;
  font-size: ${props => props.fontSize || "13px"};
  width: 100%;
`;

const Text = styled.p`
  padding: 0;
  margin: 5px 0;
  font-family: "Khmer OS Content Regular", arial, sans-serif;
  font-size: ${props => props.fontSize || "12px"};
`;

const Line = styled.div`
  background: ${JOONAAK_COLOR};
  width: 100%;
  height: 2px;
`;

const CenterContainer = styled.div`
  text-align: center;
  padding: 15px 0;
`;

const AddressContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-around;
  margin-bottom: 10px;
`;

const AddressTextBold = styled(BoldText)`
  text-align: right;
  margin: 5px 0;
  font-size: 12px;
`;

const FlexItem = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const StyledTable = styled.table`
  font-family: "Khmer OS Content Regular", arial, sans-serif;
`;

const BottomContainer = styled.div`
  margin: ${props => props.moreSpace && "30px"} 0 0 0;
  flex: 1;
`;

const NoteText = styled.p`
  font-size: 10px;
  font-family: "Khmer OS Content Regular", arial, sans-serif;
  padding: 0;
  margin: 2px 0;
`;

const Page2 = styled.div`
  flex: 1;
  padding: 50px 0 0 0;
`;

const SignContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-bottom: 50px;
`;
class InvoicePrint extends React.Component {

  renderAddress = deliveryOrder => {
    const { selectedReceiverAddress, province } = deliveryOrder;
    return getAddressText(selectedReceiverAddress, province);
  };

  render() {
    const { printProps } = this.props;
    let senderData = {
      id: _.get(printProps, "sender.id"),
      name: _.get(printProps, "sender.name"),
      phoneNumbers: _.get(printProps, "sender.phoneNumbers"),
      bankName: _.get(printProps, "sender.bankName"),
      bankAccountNumber: _.get(printProps, "sender.bankAccountNumber"),
      insurancePercentage: _.get(printProps, "sender.insurancePercentage"),
      zone1Price: _.get(printProps, "sender.zone1Price"),
      zone2Price: _.get(printProps, "sender.zone2Price"),
      zone3Price: _.get(printProps, "sender.zone3Price"),
      provinceTransferFee: _.get(printProps, "sender.provinceTransferFee"),
      cashOnDeliveryFee: _.get(printProps, "sender.cashOnDeliveryFee"),
      streetName: _.get(printProps, "sender.streetName"),
      VATNumber: _.get(printProps, "sender.VATNumber"),
      isTax: _.get(printProps, "sender.isTax"),
      isShowInvoiceHeader: _.get(printProps, "sender.isShowInvoiceHeader"),
      pickPackFee: _.get(printProps, "sender.pickPackFee"),
      returnFee: _.get(printProps, "sender.returnFee"),
      expressZone1Price: _.get(printProps, "sender.expressZone1Price"),
      expressZone2Price: _.get(printProps, "sender.expressZone2Price"),
      expressZone3Price: 5,
      joonaakZonePrice: 0.5,
      isUsingPickPack: _.get(printProps, "sender.isUsingPickPack"),
      address: {
        houseNumber: _.get(printProps, "sender.selectedAddress.houseNumber"),
        streetNumber: _.get(printProps, "sender.selectedAddress.streetNumber"),
        streetName: _.get(printProps, "sender.selectedAddress.streetName"),
        sangkat: _.get(printProps, "sender.selectedAddress.sangkat"),
        khan: _.get(printProps, "sender.selectedAddress.khan"),
        province: _.get(printProps, "sender.selectedAddress.province"),
        other: _.get(printProps, "sender.selectedAddress.other")
      }
    };

    let warehouseInfo = {
      wareHouseForMonth: _.get(printProps, "wareHouseDate"),
      wareHouseDate: _.get(printProps, "sender.wareHouseDate"),
      wareHouseUnitPrice: _.get(printProps, "wareHouseUnitPrice"),
      SKUQty: _.get(printProps, "SKUQty"),
      wareHouseSize: _.get(printProps, "wareHouseSize"),
      SKUUsed: _.get(printProps, "SKUUsed"),
      SKUPrice: _.get(printProps, "SKUPrice")
    };

    let warehouseCalculation = getWareHouseCalculation(
      warehouseInfo.wareHouseSize,
      warehouseInfo.wareHouseUnitPrice,
      warehouseInfo.SKUQty,
      warehouseInfo.SKUUsed,
      warehouseInfo.SKUPrice
    );

    let BUS_FEE = _.get(senderData, "provinceTransferFee");
    let COD_FEE = (_.get(senderData, "cashOnDeliveryFee") * 1) / 100;
    let INSURANCE_FEE = (_.get(senderData, "insurancePercentage") * 1) / 100;
    let PICK_PACK_FEE = _.get(senderData, "pickPackFee");
    let RETURN_FEE = _.get(senderData, "returnFee");
    let EXPERSS_ZONE_ONE_FEE = _.get(senderData, "expressZone1Price");
    let EXPERSS_ZONE_TWO_FEE = _.get(senderData, "expressZone2Price");
    let EXPERSS_ZONE_THREE_FEE = _.get(senderData, "expressZone3Price");
    let JOONAAK_ZONE_FEE = _.get(senderData, "joonaakZonePrice");
    let totalCollectedDollar = 0;
    let totalCollectedRiel = 0;
    let totalOtherExpend = 0;
    let insuranceAmount = 0;
    let insuranceFullPrice = 0;
    let dimensionCalculated = 0;
    let totalDimensionCalculated = 0;
    let overWeightPrice = 0.25;
    let recycleZoneOneCount = 0;
    let recycleZoneTwoCount = 0;
    let recycleZoneThreeCount = 0;
    let busOrTaxiFeeTotal = 0;
    let packageRequestDeliveryOrderCount = 0;
    let expressZoneOneCount = 0;
    let expressZoneTwoCount = 0;
    let expressZoneThreeCount = 0;
    let declarePriceHasValueCount = 0; // Check if decalare price forgot input
    let returnItemCount = 0;
    let extraCharge = 0;
    let extraChargeCount = 0;
    _.get(printProps, "deliveryOrders").map((deliveryOrder, index) => {
      if (_.get(deliveryOrder, "otherExpend")) {
        totalOtherExpend += _.get(deliveryOrder, "otherExpend");
      }
      //Check if transfer money by "agency"
      if (deliveryOrder.paymentType == "transfer") {
        totalCollectedDollar += deliveryOrder.transferAmount;
        totalCollectedRiel += deliveryOrder.transferAmountRiel;
      } else {
        totalCollectedDollar += deliveryOrder.collectedDollar;
        totalCollectedRiel += deliveryOrder.collectedRiel;
      }

      if (
        _.has(deliveryOrder, "extraCharge") &&
        _.get(deliveryOrder, "extraCharge") > 0
      ) {
        extraCharge =
          parseFloat(extraCharge) +
          parseFloat(_.get(deliveryOrder, "extraCharge"));
        extraChargeCount += 1;
      }

      if (
        parseFloat(senderData.insurancePercentage) > 0 &&
        _.get(deliveryOrder, "serviceType") !== "return"
      ) {
        insuranceAmount += 1;
        insuranceFullPrice += deliveryOrder.declarePrice;
        if (parseFloat(deliveryOrder.declarePrice) > 0) {
          declarePriceHasValueCount += 1;
        }
      }

      if (
        _.get(deliveryOrder, "serviceType") == "return" &&
        (deliveryOrder.zone == null ||
          deliveryOrder.zone == "" ||
          deliveryOrder.zone == "0")
      ) {
        returnItemCount += 1;
      }

      if (deliveryOrder.isExpress) {
        if (deliveryOrder.zone == 1) {
          expressZoneOneCount += 1;
        } else if (deliveryOrder.zone == 2) {
          expressZoneTwoCount += 1;
        } else if (deliveryOrder.zone == 3) {
          expressZoneThreeCount += 1;
        }
      }

      // Check if this delivery order count in package request fee
      if (
        deliveryOrder.packageRequest ||
        senderData.isUsingPickPack ||
        _.get(deliveryOrder, "deliveryOrder.includePickpack")
      ) {
        packageRequestDeliveryOrderCount += 1;
      }

      if (
        deliveryOrder.isProvinceTransfer &&
        parseFloat(deliveryOrder.busOrTaxiFee) > 0
      ) {
        busOrTaxiFeeTotal += deliveryOrder.busOrTaxiFee;
      }

      let {
        dimensionHeight,
        dimensionWidth,
        dimensionLength,
        weight
      } = deliveryOrder;

      let itemCalculate = overweight_calculate(
        dimensionLength,
        dimensionWidth,
        dimensionHeight,
        weight
      );

      if (itemCalculate > 0) {
        dimensionCalculated += itemCalculate;
      }
    });
    let zoneOneQTY = getStandardDeliveryQTYByZone(printProps.deliveryOrders, 1);
    let zoneOneCycleQTY = getStandardCycleDeliveryQTYByZone(
      printProps.deliveryOrders,
      1
    );

    let zoneTwoQTY = getStandardDeliveryQTYByZone(printProps.deliveryOrders, 2);
    let zoneTwoCycleQTY = getStandardCycleDeliveryQTYByZone(
      printProps.deliveryOrders,
      2
    );

    let zoneThreeQTY = getStandardDeliveryQTYByZone(
      printProps.deliveryOrders,
      3
    );

    let joonaakZoneQTY = getStandardDeliveryQTYByZone(
      printProps.deliveryOrders,
      "joonaak"
    );

    let zoneThreeCycleQTY = getStandardCycleDeliveryQTYByZone(
      printProps.deliveryOrders,
      3
    );

    let provinceQTY = getProvinceQTY(printProps.deliveryOrders);

    recycleZoneOneCount += zoneOneCycleQTY;
    recycleZoneTwoCount += zoneTwoCycleQTY;
    recycleZoneThreeCount += zoneThreeCycleQTY;

    //exchange zone with express price
    zoneOneQTY = zoneOneQTY - expressZoneOneCount;
    zoneTwoQTY = zoneTwoQTY - expressZoneTwoCount;
    zoneThreeQTY = zoneThreeQTY - expressZoneThreeCount;

    let standardDeliveryOrderZoneOneTotalPrice = getAmountInUSD(
      zoneOneQTY,
      senderData.zone1Price
    );
    let standardDeliveryOrderZoneTwoTotalPrice = getAmountInUSD(
      zoneTwoQTY,
      senderData.zone2Price
    );

    let standardDeliveryOrderZoneThreeTotalPrice = getAmountInUSD(
      zoneThreeQTY,
      senderData.zone3Price
    );

    let standardDeliveryOrderJoonaakZoneTotalPrice = getAmountInUSD(
      joonaakZoneQTY,
      JOONAAK_ZONE_FEE
    );

    let collectedFullPrice = totalCollectedRiel / 4000 + totalCollectedDollar;

    let recycleZoneOneFee = recycleZoneOneCount * RETURN_FEE;
    let recycleZoneTwoFee = recycleZoneTwoCount * RETURN_FEE;
    let recycleZoneThreeFee = recycleZoneThreeCount * RETURN_FEE;
    let zoneRecycleFee =
      recycleZoneOneFee + recycleZoneTwoFee + recycleZoneThreeFee;

    if (RETURN_FEE == 0 || RETURN_FEE == "" || RETURN_FEE == null) {
      zoneRecycleFee = 0;
    }

    // Manually overrided recycleFee while currently operation cannot charge from sender
    zoneRecycleFee = 0;

    let packageRequestDeliveryOrderFee =
      packageRequestDeliveryOrderCount * PICK_PACK_FEE;

    let expressZone1Fee = expressZoneOneCount * EXPERSS_ZONE_ONE_FEE;
    let expressZone2Fee = expressZoneTwoCount * EXPERSS_ZONE_TWO_FEE;
    let expressZone3Fee = expressZoneThreeCount * EXPERSS_ZONE_THREE_FEE;
    let serviceReturnFee = returnItemCount * RETURN_FEE;
    let provincialTotalPrice = getAmountInUSD(provinceQTY, BUS_FEE);
    let codFeeTotalPrice = getAmountInUSD(collectedFullPrice, COD_FEE) || 0;

    //TO BE CHANGE TO insuranceFullPrice
    let insuranceTotalPrice = getAmountInUSD(collectedFullPrice, INSURANCE_FEE);
    totalDimensionCalculated = dimensionCalculated * overWeightPrice;

    let totalPrice = getTotal(
      standardDeliveryOrderZoneOneTotalPrice,
      standardDeliveryOrderZoneTwoTotalPrice,
      standardDeliveryOrderZoneThreeTotalPrice,
      standardDeliveryOrderJoonaakZoneTotalPrice,
      provincialTotalPrice,
      codFeeTotalPrice,
      insuranceTotalPrice,
      totalDimensionCalculated,
      packageRequestDeliveryOrderFee,
      zoneRecycleFee,
      expressZone1Fee,
      expressZone2Fee,
      expressZone3Fee,
      serviceReturnFee,
      extraCharge
    );

    if (_.get(printProps, "isIncludeWarehouse")) {
      totalPrice = totalPrice + warehouseCalculation;
    }

    let isTaxInvoice =
      senderData.VATNumber !== "" && senderData.VATNumber !== null;
    console.log('----------------- deliveryorders: ',printProps.deliveryOrders)
    return (
      <Container>
        {totalPrice > 0 &&  (
          <div>

            {
              (senderData.isTax == true || senderData.isShowInvoiceHeader == true) && (
                <>
                <Header>
                  <BoldText>ជូនអ្នក អេនធើប្រាយ សឺលូសិន ខូអិលធីឌី11</BoldText>
                  <BoldText fontSize="12px">
                    Joonaak Enterprise Solutions Co., Ltd
                  </BoldText>
                  <Text>អត្តសញ្ញាណកម្ម អតប (VAT TIN): K005-901800431</Text>
                  <Text>
                    ផ្ទះលេខ 26 AEo ផ្លូវលេខ 138 ភូមិ 7 សង្កាត់ ផ្សារដេប៉ូទី២ ខណ្ឌ ទួលគោក រាជធានីភ្នំពេញ កម្ពុជា
                  </Text>
                  <Text>
                    #26, AEo, Street 138, Village 7, Phsar Depo II Commune, Tuol Kork District, Phnom Penh Capital, Cambodia
                  </Text>
                  <Text>010 984 988 | 011 984 988</Text>
                </Header>
                <Line />
                </>
              )
            }

            <CenterContainer>
              <BoldText fontSize="15px">
                {isTaxInvoice ? "វិក្កយបត្រអាករ" : "វិក្កយបត្រ"}
              </BoldText>
              <BoldText fontSize="13px">
                {isTaxInvoice ? "TAX INVOICE" : "INVOICE"}
              </BoldText>
            </CenterContainer>
            <AddressContainer>
              <FlexItem>
                <Text>ឈ្មោះក្រុមហ៊ុន ឬអតិថិជន (Company/Customer Name):</Text>
                {isTaxInvoice && <Text>លេខអត្តសញ្ញាណកម្ម អតប (VAT TIN):</Text>}
                <Text>អាសយដ្ធាន (Address):</Text>
                {senderData.phoneNumbers[0] && (
                  <Text>លេខទូរសព្ទ (Phone number):</Text>
                )}
                <Text>លេខគណនេយ្យធនាគារ (ABA Bank):</Text>
                <Text>លេខរៀងវិក្កយបត្រ (Invoice No.):</Text>
                <Text>កាលបរិច្ឆេទវិក្កយបត្រ (Invoice Date):</Text>
              </FlexItem>
              <FlexItem>
                <AddressTextBold>{senderData.name}</AddressTextBold>
                {isTaxInvoice && (
                  <AddressTextBold>{senderData.VATNumber}</AddressTextBold>
                )}
                <AddressTextBold>
                  {getAddressText(senderData.address)}, Cambodia
                </AddressTextBold>
                {senderData.phoneNumbers[0] && (
                  <AddressTextBold>
                    {senderData.phoneNumbers[0].pretty}
                  </AddressTextBold>
                )}
                <AddressTextBold>
                  {_.get(senderData, "bankName")
                    ? senderData.bankName + " : "
                    : "N/A"}
                  {_.get(senderData, "bankAccountNumber") !== "" &&
                    senderData.bankAccountNumber}
                </AddressTextBold>
                <AddressTextBold>{printProps.number}</AddressTextBold>
                <AddressTextBold>
                  {moment(printProps.createdAt).format("DD/MM/YYYY")}
                </AddressTextBold>
              </FlexItem>
            </AddressContainer>

            <StyledTable className="invoice-table">
              <thead>
                <tr>
                  <th>
                    បរិយាយមុខទំនិញ <br />
                    Description
                  </th>
                  <th width="10%">
                    បរិមាណ <br />
                    Quantity
                  </th>
                  <th width="20%">
                    តម្លៃឯកត្តា <br />
                    Unit Price
                  </th>
                  <th width="20%">
                    ទឹកប្រាក់ដុល្លារអាមេរិក <br />
                    Amount in USD
                  </th>
                </tr>
              </thead>
              <tbody>
                {zoneOneQTY > 0 && (
                  <tr>
                    <td>
                      Standard Delivery Zone 1 (reopen {recycleZoneOneCount}
                      {singleOrPlural(" time", recycleZoneOneCount)})
                    </td>
                    <td>{zoneOneQTY}</td>
                    <td>{currency_format(senderData.zone1Price)}</td>
                    <td>
                      {currency_format(standardDeliveryOrderZoneOneTotalPrice)}
                    </td>
                  </tr>
                )}
                {zoneTwoQTY > 0 && (
                  <tr>
                    <td>
                      Standard Delivery Zone 2 (reopen {recycleZoneTwoCount}{" "}
                      {singleOrPlural(" time", recycleZoneTwoCount)})
                    </td>
                    <td>{zoneTwoQTY}</td>
                    <td>{currency_format(senderData.zone2Price)}</td>
                    <td>
                      {currency_format(standardDeliveryOrderZoneTwoTotalPrice)}
                    </td>
                  </tr>
                )}
                {zoneThreeQTY > 0 && (
                  <tr>
                    <td>
                      Standard Delivery Zone 3 (reopen {recycleZoneThreeCount}{" "}
                      {singleOrPlural(" time", recycleZoneThreeCount)})
                    </td>
                    <td>{zoneThreeQTY}</td>
                    <td>{currency_format(senderData.zone3Price)}</td>
                    <td>
                      {currency_format(
                        standardDeliveryOrderZoneThreeTotalPrice
                      )}
                    </td>
                  </tr>
                )}
                {joonaakZoneQTY > 0 && (
                  <tr>
                    <td>Pickup at Joonaak</td>
                    <td>{joonaakZoneQTY}</td>
                    <td>{currency_format(JOONAAK_ZONE_FEE)}</td>
                    <td>
                      {currency_format(
                        standardDeliveryOrderJoonaakZoneTotalPrice
                      )}
                    </td>
                  </tr>
                )}
                {provinceQTY > 0 && (
                  <tr>
                    <td>Provincial Transfer</td>
                    <td>{provinceQTY}</td>
                    <td>{currency_format(BUS_FEE)}</td>
                    <td>{currency_format(provincialTotalPrice)}</td>
                  </tr>
                )}
                {codFeeTotalPrice > 0 && (
                  <tr>
                    <td>COD fee</td>
                    <td>{currency_format(collectedFullPrice, 2)}</td>
                    <td>{COD_FEE * 100} %</td>
                    <td>{currency_format(codFeeTotalPrice)}</td>
                  </tr>
                )}

                {parseFloat(expressZone1Fee) > 0 && (
                  <tr>
                    <td>Express zone 1</td>
                    <td>
                      {expressZoneOneCount}
                      {parseFloat(expressZoneOneCount) > 1 ? " items" : " item"}
                    </td>
                    <td>{currency_format(EXPERSS_ZONE_ONE_FEE)}</td>
                    <td>{currency_format(expressZone1Fee)}</td>
                  </tr>
                )}

                {parseFloat(extraCharge) > 0 && (
                  <tr>
                    <td>Extra charge</td>
                    <td>
                      {extraChargeCount}
                      {parseFloat(extraChargeCount) > 1 ? " items" : " item"}
                    </td>
                    <td />
                    <td>{currency_format(extraCharge)}</td>
                  </tr>
                )}

                {returnItemCount > 0 && (
                  <tr>
                    <td>Return</td>
                    <td>
                      {returnItemCount}
                      {parseFloat(returnItemCount) > 1 ? " items" : " item"}
                    </td>
                    <td>{currency_format(RETURN_FEE)}</td>
                    <td>{currency_format(serviceReturnFee)}</td>
                  </tr>
                )}

                {parseFloat(expressZone2Fee) > 0 && (
                  <tr>
                    <td>Express zone 2</td>
                    <td>
                      {expressZoneTwoCount}
                      {parseFloat(expressZoneTwoCount) > 1 ? " items" : " item"}
                    </td>
                    <td>{currency_format(EXPERSS_ZONE_TWO_FEE)}</td>
                    <td>{currency_format(expressZone2Fee)}</td>
                  </tr>
                )}

                {parseFloat(expressZone3Fee) > 0 && (
                  <tr>
                    <td>Express zone 3</td>
                    <td>
                      {expressZoneThreeCount}
                      {parseFloat(expressZoneThreeCount) > 1
                        ? " items"
                        : " item"}
                    </td>
                    <td>{currency_format(EXPERSS_ZONE_THREE_FEE)}</td>
                    <td>{currency_format(expressZone3Fee)}</td>
                  </tr>
                )}

                {parseFloat(packageRequestDeliveryOrderFee) > 0 && (
                  <tr>
                    <td>
                      Using pick pack {packageRequestDeliveryOrderCount}
                      {parseFloat(packageRequestDeliveryOrderCount) > 1
                        ? " items"
                        : " item"}
                    </td>
                    <td>{packageRequestDeliveryOrderCount}</td>
                    <td>{currency_format(PICK_PACK_FEE)}</td>
                    <td>{currency_format(packageRequestDeliveryOrderFee)}</td>
                  </tr>
                )}
                {parseFloat(zoneRecycleFee) > 0 && (
                  <tr>
                    <td>Re-delivery</td>
                    <td>
                      {recycleZoneOneCount + recycleZoneTwoCount}
                      {parseFloat(recycleZoneOneCount + recycleZoneTwoCount) > 1
                        ? " items"
                        : " item"}
                    </td>
                    <td>{currency_format(RETURN_FEE)}</td>
                    <td>{currency_format(zoneRecycleFee)}</td>
                  </tr>
                )}

                {_.get(printProps, "isIncludeWarehouse") && (
                  <tr>
                    <td>
                      Warehouse from{" "}
                      {moment(warehouseInfo.wareHouseDate).format("Do") +
                        " " +
                        moment(warehouseInfo.wareHouseForMonth).format(
                          "MMMM, YYYY"
                        )}{" "}
                      to{" "}
                      {moment(warehouseInfo.wareHouseDate).format("Do") +
                        " " +
                        moment(warehouseInfo.wareHouseForMonth)
                          .add(1, "month")
                          .format("MMMM, YYYY")}{" "}
                    </td>
                    {/* {TO BE CHANGE TO insuranceFullPrice} */}
                    <td>
                      {warehouseInfo.wareHouseSize +
                        " m³ " +
                        "(" +
                        warehouseInfo.SKUUsed +
                        " sku)"}
                    </td>
                    <td>{currency_format(warehouseInfo.wareHouseUnitPrice)}</td>
                    <td>{currency_format(warehouseCalculation)}</td>
                  </tr>
                )}

                {parseFloat(insuranceAmount) > 0 && (
                  <tr>
                    <td>
                      Insurance {insuranceAmount}
                      {parseFloat(insuranceAmount) > 1 ? " items" : " item"}(
                      {declarePriceHasValueCount} count)
                    </td>
                    {/* {TO BE CHANGE TO insuranceFullPrice} */}
                    <td>{currency_format(collectedFullPrice, 2)}</td>
                    <td>{INSURANCE_FEE * 100} %</td>
                    <td>{currency_format(insuranceTotalPrice)}</td>
                  </tr>
                )}
                {dimensionCalculated > 0 && (
                  <tr>
                    <td>Over weight</td>
                    <td>{dimensionCalculated.toFixed(2)} kg</td>
                    <td>{overWeightPrice}</td>
                    <td>{currency_format(totalDimensionCalculated)}</td>
                  </tr>
                )}
                {isTaxInvoice || senderData.isTax ? (
                  [
                    <tr key="total">
                      <td className="no-border" colSpan={3}>
                        សរុប <strong>(Subtotal)</strong>
                      </td>
                      <td>{currency_format(totalPrice)}</td>
                    </tr>,
                    <tr key="vat">
                      <td className="no-border" colSpan={3}>
                        អាករលើតម្លៃបន្ថែម ១០%
                        <strong>(VAT 10%)</strong>
                      </td>
                      <td>{currency_format(totalPrice * 0.1)}</td>
                    </tr>,
                    <tr key="grand-total">
                      <td className="no-border" colSpan={3}>
                        សរុបរួម
                        <strong>(Grand Total)</strong>
                      </td>
                      <td>{currency_format(totalPrice + totalPrice * 0.1)}</td>
                    </tr>
                  ]
                ) : (
                    <tr>
                      <td className="no-border" colSpan={3}>
                        សរុប(បូកបញ្ចូលទាំងអាករ) <br /> Total (VAT Included)
                    </td>
                      <td>{currency_format(totalPrice)}</td>
                    </tr>
                  )}
              </tbody>
            </StyledTable>

            {
              (senderData.isTax == true || senderData.isShowInvoiceHeader == true) && (
                <BottomContainer moreSpace={isTaxInvoice ? "0px" : "0px"}>
                  <NoteText>Payment shall be made in Cash or</NoteText>
                  <NoteText>
                    1. Check payable to Joonaak Enterprise Solutions Co., Ltd
                  </NoteText>
                  <NoteText>2. Bank transfer:</NoteText>
                  <NoteText>
                    Account Name: Joonaak Enterprise Solutions Co., Ltd
                  </NoteText>
                  <NoteText>Account Number: 000010200336007</NoteText>
                  <NoteText>Bank: Maybank (Cambodia) Plc</NoteText>
                  <NoteText>Swift code: MBBEKHPP</NoteText>
                  <NoteText>
                    Address: #43, Preah Sorodom Blovd, Sangkat Phsar Thmey 3, Khan
                    Daun Penh, Phnom Penh, Cambodia
                  </NoteText>
                </BottomContainer>
              )
            }

            <SignContainer className="footer">
              <Signature type="buyer" />
              <Signature />
            </SignContainer>
          </div>
        )}

        <Page2>
          <CenterContainer>
            <BoldText fontSize="15px">
              {printProps.deliveryOrders[0] && printProps.deliveryOrders[0].serviceType == "return"
                ? "RETURN "
                : "GENERAL "}
              INFORMATION
            </BoldText>
          </CenterContainer>
          <AddressContainer>
            <FlexItem>
              <Text>ឈ្មោះក្រុមហ៊ុន ឬអតិថិជន (Company/Customer Name):</Text>
              <Text>លេខរៀងវិក្កយបត្រ (Invoice No.):</Text>
              <Text>កាលបរិច្ឆេទវិក្កយបត្រ (Invoice Date):</Text>
              <Text>អត្រាប្តូរប្រាក់ (Exchange rate):</Text>
            </FlexItem>
            <FlexItem>
              <AddressTextBold>{senderData.name}</AddressTextBold>
              <AddressTextBold>{printProps.number}</AddressTextBold>
              <AddressTextBold>
                {moment(printProps.createdAt).format("DD/MM/YYYY")}
              </AddressTextBold>
              <AddressTextBold>
                {currency_format_riel(printProps.dollarToRielRate)}
              </AddressTextBold>
            </FlexItem>
          </AddressContainer>
          <StyledTable className="invoice-table">
            <thead>
              <tr>
                <th width="3%">No.</th>
                <th width="7%">Code</th>
                <th width="10%">Created on</th>
                <th width="10%">Delivered on</th>

                <th width="7%">Order name</th>
                <th width="8%">Phone number</th>
                <th width="5%">Zone</th>

                <th width="5%" className="no-print">
                  Weight
                </th>
                <th width="5%" className="no-print">
                  Amount to collect ($)
                </th>
                <th width="5%" className="no-print">
                  Amount to collect (៛)
                </th>
                <th width="7%">Dollar ($)</th>
                <th width="7%">Riels (៛)</th>
                <th width="5%">Extra charge</th>
                <th width="7%" style={{ fontSize: 8 }} className="no-print">
                  Extra Charge note
                </th>
                <th width="7%" className="no-print">
                  Declare price
                </th>
                {senderData.id == vitalBulkId && <th width="5%">Amount</th>}
                <th width="5%">Bus</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {printProps.deliveryOrders.map((deliveryOrder, index) => {
                let collectedMoneyInDollar = 0;
                {console.log('deliveryOrder.busOrTaxiFee ::> ',deliveryOrder.busOrTaxiFee)}
                let moneyToReceiveFromCustomer =
                  _.get(deliveryOrder, "receiveAmountDollars") +
                  _.get(deliveryOrder, "receiveAmountRiels") / 4000;

                if (deliveryOrder.paymentType == "transfer") {
                  collectedMoneyInDollar =
                    _.get(deliveryOrder, "transferAmount") +
                    _.get(deliveryOrder, "transferAmountRiel") / 4000;
                } else {
                  collectedMoneyInDollar =
                    _.get(deliveryOrder, "collectedDollar") +
                    _.get(deliveryOrder, "collectedRiel") / 4000;
                }

                let deliveryOrderWeight = overweight_calculate(
                  deliveryOrder.dimensionLength,
                  deliveryOrder.dimensionWidth,
                  deliveryOrder.dimensionHeight,
                  deliveryOrder.weight
                ).toFixed(2);

                return (
                  <tr
                    key={deliveryOrder.id}
                    style={{
                      backgroundColor: deliveryOrder.isExpress
                        ? "#eee"
                        : "white"
                    }}
                  >
                    <td>{index + 1}</td>
                    <td>{deliveryOrder.barCode}</td>
                    <td>
                      {deliveryOrder.serviceType == "delivered"
                        ? moment(deliveryOrder.createdAt).format(
                          "DD/MM/YYYY"
                        )
                        : moment(deliveryOrder.createdAt).format("DD/MM/YYYY")}
                    </td>
                    <td>
                      {deliveryOrder.serviceType == "delivered"
                        ? moment(deliveryOrder.deliveredDate).format(
                          "DD/MM/YYYY"
                        )
                        : moment(deliveryOrder.returnDate).format("DD/MM/YYYY")}
                    </td>

                    <td>
                      {_.get(deliveryOrder, "receiverName") || _.get(deliveryOrder, "receiver.name")}
                      {/* {numberOfDeliveryFailedArrived(deliveryOrder.recycleLogs)}
                      {singleOrPlural(
                        " time",
                        numberOfDeliveryFailedArrived(deliveryOrder.recycleLogs)
                      )} */}
                    </td>
                    <td>
                      {_.get(
                        deliveryOrder,
                        "selectedReceiverPhoneNumber.pretty",
                        ""
                      )}
                      {
                        // This is for render all related phone numbers
                      }
                      {/* {_.get(deliveryOrder, "receiver.phoneNumbers", []).map(
                        phone => {
                          if (
                            deliveryOrder.selectedReceiverPhoneNumber.pretty ==
                            phone.pretty
                          ) {
                            return (
                              <p key={phone.id}>
                                <strong>{phone.pretty}</strong>
                              </p>
                            );
                          }
                          return <p key={phone.id}>{phone.pretty}</p>;
                        }
                      )} */}
                    </td>

                    <td
                      style={
                        deliveryOrder.isProvinceTransfer
                          ? {
                            backgroundColor: "rgba(231, 76, 60,0.3)"
                          }
                          : {
                            backgroundColor: "white"
                          }
                      }
                    >
                      {deliveryOrder.zone == 1
                        ? "Zone1"
                        : deliveryOrder.zone == 2
                          ? "Zone2"
                          : deliveryOrder.zone == 3
                            ? "Zone3"
                            : deliveryOrder.zone == "joonaak"
                              ? "Joonaak"
                              : deliveryOrder.serviceType == "return"
                                ? "Cancel"
                                : "Taxi"}
                      <br />
                      <div style={{ fontSize: 8 }}>
                        {deliveryOrder.isExpress == true && "(express)"}
                        {parseFloat(deliveryOrder.extraCharge) > 0 &&
                          "(extra charge)"}
                        {parseFloat(deliveryOrder.otherExpend) > 0 &&
                          "(refund)"}
                      </div>
                    </td>

                    <td className="no-print">
                      {deliveryOrderWeight < 0
                        ? "0 kg"
                        : deliveryOrderWeight + " Kg"}
                    </td>
                    <td
                      className="no-print"
                      style={{
                        backgroundColor:
                          collectedMoneyInDollar !== moneyToReceiveFromCustomer
                            ? "rgba(231, 76, 60,0.3)"
                            : "white"
                      }}
                    >
                      {currency_format(deliveryOrder.receiveAmountDollars)}
                    </td>
                    <td
                      className="no-print"
                      style={{
                        backgroundColor:
                          collectedMoneyInDollar !== moneyToReceiveFromCustomer
                            ? "rgba(231, 76, 60,0.3)"
                            : "white"
                      }}
                    >
                      {currency_format_riel(deliveryOrder.receiveAmountRiels)}
                    </td>

                    <td>
                      {deliveryOrder.paymentType == "transfer"
                        ? currency_format(deliveryOrder.transferAmount)
                        : currency_format(deliveryOrder.collectedDollar)}
                    </td>
                    <td>
                      {deliveryOrder.paymentType == "transfer"
                        ? currency_format_riel(deliveryOrder.transferAmountRiel)
                        : deliveryOrder.collectedRiel !== 0
                          ? currency_format_riel(deliveryOrder.collectedRiel)
                          : ""}
                    </td>
                    <td>
                      {parseFloat(deliveryOrder.extraCharge) > 0 &&
                        currency_format(deliveryOrder.extraCharge)}
                    </td>

                    <td className="no-print" style={{ fontSize: 10 }}>
                      {deliveryOrder.extraChargeNote}
                    </td>

                    <td className="no-print">
                      {deliveryOrder.declarePrice
                        ? currency_format(deliveryOrder.declarePrice)
                        : ""}
                    </td>
                    {senderData.id == vitalBulkId &&
                      _.get(deliveryOrder, "packageRequest.id") && (
                        <td>
                          {_.get(
                            deliveryOrder,
                            "packageRequest.packageRequestItems[0].qty"
                          )}
                          {" Pack"}
                        </td>
                      )}
                    <td>
                      {(deliveryOrder.isProvinceTransfer || deliveryOrder.busOrTaxiFee || _.get(printProps, "sender.selectedAddress.province.id"))
                        ? currency_format(deliveryOrder.busOrTaxiFee)
                        : ""}
                    </td>
                    <td style={{ fontSize: 10 }}>
                      {this.renderAddress(deliveryOrder)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </StyledTable>
          <CenterContainer>
            <BoldText>SUMMARY</BoldText>
          </CenterContainer>
          <StyledTable style={{ width: "50%" }} className="invoice-table">
            <tbody>
              <tr>
                <td>Total Cash Collected</td>
                <td>{currency_format(totalCollectedDollar)}</td>
                <td>{currency_format_riel(totalCollectedRiel)}</td>
              </tr>
              <tr>
                <td>Joonaak fee</td>
                <td>
                  {isTaxInvoice || senderData.isTax
                    ? currency_format(totalPrice + totalPrice * 0.1)
                    : currency_format(totalPrice)}
                </td>
                <td />
              </tr>
              {totalOtherExpend > 0 && (
                <tr>
                  <td>Refund expend</td>
                  <td>{currency_format(totalOtherExpend)}</td>
                  <td />
                </tr>
              )}

              <tr>
                <td>Bus/Taxi fee</td>
                <td>{currency_format(busOrTaxiFeeTotal)}</td>
                <td />
              </tr>
              <tr>
                <td>Total Remaining</td>
                <td style={{ backgroundColor: JOONAAK_COLOR }}>
                  {currency_format(
                    totalCollectedDollar -
                    totalOtherExpend -
                    (isTaxInvoice || senderData.isTax
                      ? totalPrice + totalPrice * 0.1
                      : totalPrice) -
                    busOrTaxiFeeTotal
                  )}
                </td>
                <td style={{ backgroundColor: JOONAAK_COLOR }}>
                  {currency_format_riel(totalCollectedRiel)}
                </td>
              </tr>
            </tbody>
          </StyledTable>
        </Page2>
      </Container>
    );
  }
}

export { InvoicePrint };
export default InvoicePrint;
